import { render, staticRenderFns } from "./ComplexMenuRecucler.vue?vue&type=template&id=c647dba4&scoped=true&"
import script from "./ComplexMenuRecucler.vue?vue&type=script&lang=ts&"
export * from "./ComplexMenuRecucler.vue?vue&type=script&lang=ts&"
import style0 from "./ComplexMenuRecucler.vue?vue&type=style&index=0&id=c647dba4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c647dba4",
  null
  
)

export default component.exports